import _ from "lodash";


// menus

// 方案一 函数式 + 闭包模式
//


const constants = {
    SHIFT_DATE_DISPLAY_MODE: {
        DAYHOUR: "DAYHOUR",
        DAY: "DAY",
        HOUR: "HOUR",
    },
    ANNUAL_DATE_DISPLAY_MODE: {
        DAYHOUR: "DAYHOUR",
        DAY: "DAY",
        HOUR: "HOUR",
    },
    PLATFORM: {
        DEFAULT: "default",
        DINGDING: "dingding",
        WECHAT: "wechat",
    },
};


function normalizeUrlHash(hash) {
    return hash.replace(/^#\/?/, "");
}


let _config;
let _role;
let _apps;
let _services;
let _indexPerm;
let _corpPermission;
let _permission;
let _menus;
let _user;
let _platform;
let _editableAuthUnit;
let _ssoAccessToken;
let _versionUpgradeVisible;
let _isSwjw; // 是卫健委医院
let _swjwPermission;
let _hospitalConfig;
let _archiveConfig;
const init = (data) => {
    const {
        user,
        config,
        roles,
        indexPerms,
        corpPermissions,
        permissions,
        menus,
        apps, // 开通的应用
        services, // 开通的服务
        platform,
        versionUpgradeVisible,
        archiveConfig,
    } = data;

    _archiveConfig = archiveConfig;
    _user = user;
    _versionUpgradeVisible = versionUpgradeVisible;
    _platform = platform;

    _apps = _.chain(apps)
        .keyBy(item => item)
        .value();

    _services = _.chain(services)
        .keyBy(item => item.service)
        .value();

    _config = _.chain(config)
        .keyBy(item => item.key)
        .mapValues((item, key) => {
            if (key === "SHIFT_DATE_DISPLAY_MODE" || key === "ANNUAL_DATE_DISPLAY_MODE") {
                if (item.value === 2) {
                    return constants[key].DAY;
                } else if (item.value === 3) {
                    return constants[key].HOUR;
                } else {
                    return constants[key].DAYHOUR;
                }
            } else {
                return item.value;
            }
        })
        .value();


    _role = _.chain(roles)
        .keyBy(item => item)
        .value();


    _indexPerm = _.chain(indexPerms)
        .keyBy(item => item)
        .value();


    _corpPermission = _.chain(corpPermissions)
        .map("id")
        .keyBy(item => item)
        .value();


    _permission = _.chain(permissions)
        .keyBy(item => item)
        .value();

    _menus = _.chain(menus)
        .forEach(menu => menu.pageIndex = normalizeUrlHash(menu.pageIndex))
        .keyBy(menu => menu.pageIndex)
        .value();
};


export default {

    store: null,


    constants,
    get archiveConfig() {
        return _archiveConfig;
    },

    get hospitalConfig() {
        return _hospitalConfig;
    },
    set hospitalConfig(val) {
        _hospitalConfig = val;
    },

    get swjwPermission() {
        return _swjwPermission;
    },
    set swjwPermission(val) {
        _swjwPermission = val;
    },
    get versionUpgradeVisible() {
        return _versionUpgradeVisible;
    },
    get ssoAccessToken() {
        return _ssoAccessToken;
    },
    set ssoAccessToken(str) {
        _ssoAccessToken = str;
    },

    getIsOnlyHttp() {
        return _ssoAccessToken != null;
    },

    // or get/set ?? https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions/get
    get user() {
        return _user;
    },
    get platform() {
        return _platform;
    },

    set isSwjw(value) { // 是否卫健委医院，与市卫健委模式做区分（市卫健委模式下包括市卫健委医院与普通医院）
        _isSwjw = value;
    },
    get isSwjw() {
        return _isSwjw;
    },
    // get target() {
    //     return process.env.TARGET;
    // },

    apps: {
        has: (key) => {
            return _apps != null && _apps[key] != null;
        },
    },

    services: {
        has: (key) => {
            return _services != null && _services[key] != null;
        },
    },

    config: {
        get: (key) => {
            if (_config != null) {
                return _config[key];
            }
        },
    },
    role: {
        has: (key) => {
            return _role != null && _role[key] != null;
        },
    },
    indexPerm: {
        has: (key) => {
            return _indexPerm != null && _indexPerm[key] != null;
        },
    },


    corpPermission: {
        has: (key) => {
            return _corpPermission != null && _corpPermission[key] != null;
        },
    },

    permission: {
        has: (key) => {
            return _permission != null && _permission[key] != null;
        },
        hasArchiveFlow: () => {
            return false; // 目前未启用
            // return _permission["nurse:flow:archive:1"] || _permission["nurse:flow:archive:1"];
        },
    },

    currentModule: {
        // 模块权限
        getPermission: () => {
            const modulePath = window.location.hash;
            if (_menus != null) {
                const module = _menus[normalizeUrlHash(modulePath)];
                if (module != null) {
                    return module.perm.perm;
                }
            }
        },
    },

    editableAuthUnit: {
        has: (key) => {
            return _editableAuthUnit != null && _editableAuthUnit[key] != null;
        },
    },

    getIsUser: () => {
        return _.every(_user.roles, (role) => {
            return role.roleType === "USER";
        });
    },

    getIsManager: () => {
        return _.some(_user.roles, (role) => {
            return role.roleType === "MANAGER";
        }) && !_.some(_user.roles, (role) => {
            return role.roleType === "ADMIN" || role.roleType === "SUBADMIN";
        });
    },

    getIsAdmin: () => {
        return _.some(_user.roles, (role) => {
            return role.roleType === "ADMIN" || role.roleType === "SUBADMIN";
        });
    },

    init,
};


// 方案二 仿单例模式
// AppContext.Current.Config.get(xxx)

// export default class AppContext {
//
//     static Constants = {
//         SHIFT_DATE_DISPLAY_MODE: {
//             DAYHOUR: "DAYHOUR",
//             DAY: "DAY",
//             HOUR: "HOUR",
//         }
//     };
//
//     static Current() {
//         return this._current;
//     }
//
//     get Config() {
//         return this._config;
//     }
//
//     get User() {
//         return this._user;
//     }
//
//
//
//     initUser(user) {
//         this._user = user;
//     }
//     initConfig(cfg) {
//
//         // SHIFT_DEDUT_STD_HOURS_AVAILABLE
//         // SHIFT_DATE_DISPLAY_MODE
//
//         const data = _.chain(cfg)
//             .keyBy(item => item.key)
//             .mapValues((item, key) => {
//                 if (key === "SHIFT_DATE_DISPLAY_MODE") {
//                     if (item.value === 2) {
//                         return AppContext.Constants.SHIFT_DATE_DISPLAY_MODE.DAY;
//
//                     } else if (item.value === 3) {
//                         return AppContext.Constants.SHIFT_DATE_DISPLAY_MODE.HOUR;
//
//                     } else {
//                         return AppContext.Constants.SHIFT_DATE_DISPLAY_MODE.DAYHOUR;
//                     }
//                 } else {
//                     return item.value;
//                 }
//             })
//             .value();
//
//
//         this._config = {
//             get: key => {
//                 if (data != null) {
//                     return data[key];
//                 }
//             },
//         }
//     }
// }

// 方案三 静态函数
// AppContext.Config.get(xxx)

// let _config;
// export default class AppContext {
//
//     static Constants = {
//         SHIFT_DATE_DISPLAY_MODE: {
//             DAYHOUR: "DAYHOUR",
//             DAY: "DAY",
//             HOUR: "HOUR",
//         }
//     };
//
//
//
//     static get Config() {
//         // (1)
//         return _config;
//     }
//     static get User() {
//         // (2)
//         return AppContext._user;
//     }
//
//
//
//     initUser(user) {
//         AppContext._user = user;
//     }
//     initConfig(cfg) {
//
//         // SHIFT_DEDUT_STD_HOURS_AVAILABLE
//         // SHIFT_DATE_DISPLAY_MODE
//
//         const data = _.chain(cfg)
//             .keyBy(item => item.key)
//             .mapValues((item, key) => {
//                 if (key === "SHIFT_DATE_DISPLAY_MODE") {
//                     if (item.value === 2) {
//                         return AppContext.Constants.SHIFT_DATE_DISPLAY_MODE.DAY;
//
//                     } else if (item.value === 3) {
//                         return AppContext.Constants.SHIFT_DATE_DISPLAY_MODE.HOUR;
//
//                     } else {
//                         return AppContext.Constants.SHIFT_DATE_DISPLAY_MODE.DAYHOUR;
//                     }
//                 } else {
//                     return item.value;
//                 }
//             })
//             .value();
//
//
//         _config = {
//             get: key => {
//                 if (data != null) {
//                     return data[key];
//                 }
//             },
//         }
//     }
// }
